export const environment = {
    production: true,
    baseurl: '/v3/',
    base_api_url: '/MyRemedi',
    airbrake_projectid: '220196',
    airbrake_key: '4da0d0e5865981c213bdc5c2b9dd1474'
};
